// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson
// Juice: screen shake, a burst of critter-coloured confetti, and a reveal stamp.
import { CRITTER_COLOR } from './critters';
import type { CritterType } from './game';

let reduced = false;
export function setReducedMotion(r: boolean): void {
  reduced = r;
}

export function shake(el: HTMLElement, intensity = 1): void {
  if (reduced) return;
  el.style.setProperty('--shake', String(intensity));
  el.classList.remove('shaking');
  void el.offsetWidth; // restart the animation
  el.classList.add('shaking');
  window.setTimeout(() => el.classList.remove('shaking'), 420);
}

export function burst(root: HTMLElement, x: number, y: number, type: CritterType, big = false): void {
  if (reduced) return;
  const color = CRITTER_COLOR[type];
  const n = big ? 22 : 12;
  for (let i = 0; i < n; i++) {
    const p = document.createElement('span');
    p.className = 'particle';
    const ang = (Math.PI * 2 * i) / n + Math.random() * 0.5;
    const dist = (big ? 90 : 55) * (0.5 + Math.random());
    p.style.setProperty('--dx', `${Math.cos(ang) * dist}px`);
    p.style.setProperty('--dy', `${Math.sin(ang) * dist}px`);
    p.style.left = `${x}px`;
    p.style.top = `${y}px`;
    p.style.background = color;
    root.appendChild(p);
    window.setTimeout(() => p.remove(), 700);
  }
}

export function stamp(root: HTMLElement, text: string, good: boolean): void {
  const s = document.createElement('div');
  s.className = `stamp ${good ? 'good' : 'bad'}${reduced ? ' reduced' : ''}`;
  s.textContent = text;
  root.appendChild(s);
  window.setTimeout(() => s.remove(), 1100);
}
